var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-container" }, [
      _c("div", { staticClass: "main" }, [
        _c("a", {
          staticClass: "title",
          attrs: { title: "新明辉星云系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "ssn1 system",
          attrs: { title: "仓储管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "ssn2 system",
          attrs: { title: "大客户项目管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "ssn3 system",
          attrs: { title: "生产管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "ssn4 system",
          attrs: { title: "售后管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "wms system",
          attrs: { title: "财务管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "shop system",
          attrs: { title: "商城后台管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "pic system1",
          attrs: { title: "价格管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "oa system",
          attrs: { title: "办公自动化", target: "_blank" }
        }),
        _c("a", {
          staticClass: "crm system",
          attrs: { title: "订单管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "das system",
          attrs: { title: "权限管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "fms system",
          attrs: { title: "物流管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "scm system",
          attrs: { title: "人力资源管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "library system",
          attrs: { title: "智慧餐厅", target: "_blank" }
        }),
        _c("a", {
          staticClass: "elearning system",
          attrs: { title: "商学院学习系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "pda system1",
          attrs: { title: "客户管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "ask system",
          attrs: { title: "虚拟库存系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "rma system",
          attrs: { title: "供应商管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "eps system1",
          attrs: { title: "固定资产管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "edi system1",
          attrs: { title: "商城运营系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "dam system1",
          attrs: { title: "第三方店铺系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "order system1",
          attrs: { title: "预算管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "erp system1",
          attrs: { title: "大数据分析系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "tms system1",
          attrs: { title: "工单管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "scale system1",
          attrs: { title: "新明辉商城", target: "_blank" }
        }),
        _c("a", {
          staticClass: "srm system1",
          attrs: { title: "商品管理系统", target: "_blank" }
        }),
        _c("a", {
          staticClass: "hlm system1",
          attrs: { title: "员工问答系统", target: "_blank" }
        }),
        _c("div", { staticClass: "star-base star-ssn1" }),
        _c("div", { staticClass: "star-base star-wms" }),
        _c("div", { staticClass: "star-base star-wms1" }),
        _c("div", { staticClass: "star-base star-wms2" }),
        _c("div", { staticClass: "star-base star-wms3" }),
        _c("div", { staticClass: "star-base star-wms4" }),
        _c("div", { staticClass: "star-base star-wms5" }),
        _c("div", { staticClass: "star-base star-wms6" }),
        _c("div", { staticClass: "star-base star-wms7" }),
        _c("div", { staticClass: "star-base star-wms8" }),
        _c("div", { staticClass: "star-base star-wms9" }),
        _c("div", { staticClass: "star-base star-wms10" }),
        _c("div", { staticClass: "star-base star-oa" }),
        _c("div", { staticClass: "star-base star-oa1" }),
        _c("div", { staticClass: "star-base star-oa2" }),
        _c("div", { staticClass: "star-base star-oa3" }),
        _c("div", { staticClass: "star-base star-oa4" }),
        _c("div", { staticClass: "star-base star-oa5" }),
        _c("div", { staticClass: "star-base star-oa6" }),
        _c("div", { staticClass: "star-base star-oa7" }),
        _c("div", { staticClass: "star-base star-oa8" }),
        _c("div", { staticClass: "star-base star-oa9" }),
        _c("div", { staticClass: "star-base star-oa10" }),
        _c("div", { staticClass: "img" }, [
          _c("img", { attrs: { src: require("static/images/ad/main-bg.png") } })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b1d4cd5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b1d4cd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/index/banner/right-announce.vue
// module id = ajuP
// module chunks = 2